import type { MarketDataSnapshot } from '../types';
import { toBig } from './number';

/**
 * Given a MarketDataSnapshot, will grab the top of book bid and offer and return the mid based on those
 * If either the top of book bid or offer do not exist, returns undefined
 */
export function getMarketDataSnapshotMid(mds: MarketDataSnapshot | undefined): string | undefined {
  if (!mds) {
    return undefined;
  }

  const topOfBookBid = toBig(mds.Bids?.at(0)?.Price);
  const topOfBookOffer = toBig(mds.Offers?.at(0)?.Price);

  if (!topOfBookBid || !topOfBookOffer) {
    return undefined;
  }

  return topOfBookBid.plus(topOfBookOffer).div(2).toFixed();
}
